import {useGetLogbookCategoriesQuery} from '@apis/logbook'
import type {LogbookCategoryInterface} from '@interfaces/logbook/logbook'
import {usePagedOptions} from '@shared/hooks/usePagedOptions'

const useLogbookCategoryPage = ({
  search,
  limit,
}: {
  search: string
  limit: number
}): {data?: {count: number; results: LogbookCategoryInterface[]}; isFetching: boolean} =>
  useGetLogbookCategoriesQuery({limit, offset: 0, ordering: 'name', ...(search ? {search} : {})})

/**
 * The tenant's logbook categories for a `Picker`, searched and paged on the
 * server — the entry form and the logbook filter both pick from the full list,
 * not from whatever categories happen to be on the rows already loaded.
 */
export const useLogbookCategoryOptions = (): ReturnType<
  typeof usePagedOptions<LogbookCategoryInterface>
> => usePagedOptions(useLogbookCategoryPage)
